module.exports = __webpack_public_path__ + "static/media/aviadbio.7d6037a5.png";